import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { RevenueSummary } from '@app/shared/models/financial-overview.model';
import { SelectedRange } from '@app/shared/models/volume-dashboard.model';

@Component({
  selector: 'app-revenue-report',
  templateUrl: './revenue-report.component.html',
  styleUrl: './revenue-report.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class RevenueReportComponent {
  @Input() report: RevenueSummary | null = null;
  @Input() selectedRange: SelectedRange | null = null;

  get hasData(): boolean {
    return (this.report?.totals.total.value ?? 0) > 0;
  }

  get hasPercent(): boolean {
    return this.report?.totals.total.diffPercent != null;
  }

  get comparisonValue(): number | null {
    if (!this.report) return null;
    return this.hasPercent ? this.report.totals.total.diffPercent : this.report.totals.total.diffAbsolute;
  }

  get sourceRows() {
    if (!this.report) return [];
    const total = this.report.totals.total.value;
    return [
      { key: 'dropOff', label: 'App.Charts.dropOff', value: this.report.sources.dropOff },
      { key: 'hal', label: 'App.Charts.hal', value: this.report.sources.hal },
      { key: 'subscription', label: 'App.Admin.Dashboard.Revenue.Subscription', value: this.report.sources.subscription },
      { key: 'overage', label: 'App.Admin.Dashboard.Revenue.Overage', value: this.report.sources.overage },
    ].map((row) => ({ ...row, width: total > 0 ? row.value / total * 100 : 0 }));
  }
}
